import React from 'react';
import styled from 'styled-components';
import { motion } from 'framer-motion';
import Header from './components/Header';
import Hero from './components/Hero';
import About from './components/About';
import Projects from './components/Projects';
import Skills from './components/Skills';
import Contact from './components/Contact';
import './App.css';

const AppContainer = styled.div`
  min-height: 100vh;
  background: linear-gradient(135deg, #000 0%, #1a1a1a 100%);
`;

const MainContent = styled.main`
  width: 100%;
`;

function App() {
  return (
    <AppContainer>
      <Header />
      <MainContent>
        <Hero />
        <About />
        <Skills />
        <Projects />
        <Contact />
      </MainContent>
    </AppContainer>
  );
}

export default App;
